export default "/institutions/sofisa.svg";